<template>
    <v-dialog v-model="show" max-width="580" :fullscreen="$vuetify.breakpoint.xs" scrollable>
      <v-card>
          <v-card-title class="headline primary--text fixNotchPaddingTop rundown-dialog-head">
          {{$t('NEW_FEATURES_HEADER')}}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>


            <v-container>
 
                <section class="text-not-centered"> 
                    <v-row v-for="(change, index) in changes" :key="index" class="mb-5">
                        <h3 class="dev"> {{change.date}} </h3>
                        <ul>
                            <li v-for="(item, itemIndex) in change.items" :key="itemIndex">{{item}}</li>
                        </ul> 
                    </v-row>
                </section>
            </v-container>


        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="fixNotchPaddingBottom">
            <v-spacer></v-spacer>
                <v-btn color="secondary rundown-dialog-btn" 
                    @click="show = false">{{$t("NEW_FEATURES_BTN")}}</v-btn>
                </v-card-actions>
            </v-card>
          </v-dialog>
</template>


<script>
//import componet from './path';

export default {
  name: "NewFeatures",
  components: {},
  props: {},
  data() {
    return {
      show: false,
      changes: [],
    };
  },
  methods: {
    handleNewFeatures(welcomeShown) {
      if (!window.rundownApp || !window.rundownApp.localStorage) {
        setTimeout( function() {
          this.handleNewFeatures(welcomeShown) }, 2000);
        return;
      }

      const item = "new-feature-rundown-shown-" + this.$t("NEW_FEATURES_VERSION");
        
      window.rundownApp.localStorage.getItem(item, (value) => {

        //console.log(value);
        if (value) return;

        this.changes = this.$t('NEW_FEATURES_CHANGE_LOG')

        if (!welcomeShown)    //No mostramos el change log si hemos mostrado nuevas pantallas gráficas
            this.show = true;
        
        window.rundownApp.localStorage.setItem(item, true);
      });
    },
  },
  filters: {},
  computed: {},
  created() {},
  mounted() {},
  updated() {},
  destroyed() {},
};
</script>


<style>
</style>